<!-- 推广账户管理 - 微博 -->
<template>
<div>
	<div style="display: flex;align-items: center;">
		<div v-for="(item,index) in titleTab" :key="index" 
		:class="{'title-tab-box-selected': item.select}" 
		@click="changeTab(item,index)"
		class="title-tab-box">{{item.label}}</div>
	</div>
	
	<div v-show="content_type == 0">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0 0;">
			<div class="screen-box">
				<div class="screen-label">推广账户名称</div>
				<a-input v-model="r_adv_name" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">负责人</div>
				
				<adminSelect @handleChangeSelect="handleChangeA"></adminSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">开发者账户</div>
				<a-select
					showSearch
					style="min-width: 200px"
					placeholder="请选择开发者账户"
					@change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in ToutiaoList" :key="item.id" :value="item.id" :title="item.account_name">
					  {{item.account_name}}
					</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
			<a-button @click="showPlAccID()" class="screen-box" type="primary">批量搜索账户ID</a-button>
			<a-button class="screen-box" @click="setFZR" type="primary">批量设置负责人（已选{{selectedData.length}}项）</a-button>
		</div>

		<div>
			<!-- 表头 -->
			<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
				<div class="table-th-cell"
				:style="{'width':50 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				
				<div  v-for="(item,index) in rableTitle" :key="index" >
					<div class="table-th-cell" 
					:style="{'width':item.width + 'px',}">
						{{item.title}}
					</div>
				</div>
			</div>
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':50 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_tem.type !='admin_user' && z_tem.type !='refresh_expires_in' && z_tem.type !='sync_data' && z_tem.type !='auth' && z_tem.type !='cz' && z_tem.type != 'effective_status'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
					<div v-else-if="z_tem.type =='admin_user'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}" @click="setFZRShow(item)">
						<div v-if="Object.keys(item.admin_user).length > 0" style="display: flex;align-items: center;flex-wrap: wrap;cursor: pointer;">
							<div v-for="(value,key) in item.admin_user" :key="key" style="color: #2F88FF;margin: 0 7px 3px 0;">
								{{value}}
							</div>
						</div>
						<div v-else style="color: #62a8ea;cursor: pointer;">
							未设置
						</div>
					</div>
					<!-- 授权有效期 -->
					<div v-else-if="z_tem.type == 'refresh_expires_in'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}} <span v-if="item.refresh_expires_text" style="color: red;">（{{item.refresh_expires_text}}）</span>
					</div>
					<!-- 是否开启同步数据 -->
					<div v-else-if="z_tem.type == 'sync_data'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type] == 1?'是':'否'}}
					</div>
					<!-- 是否授权 -->
					<div v-else-if="z_tem.type == 'auth'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type] == 1?'是':'否'}}
					</div>
					<!-- 计划状态 -->
					<div v-else-if="z_tem.type == 'effective_status'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type] | shStatusFilters}}
					</div>
					
				</template>
				
			</div>
			
			<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_scroll_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	<div v-show="content_type == 1" style="margin-top: 30px;">
		<wbDevPage></wbDevPage>
	</div>
	<div v-show="content_type == 2" style="margin-top: 30px;">
		<wbAgentPage></wbAgentPage>
	</div>
	
	<!-- 批量设置负责人 -->
	<a-modal :visible="pl_modal" title="批量设置负责人" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的负责人</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择负责人"
					@change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
					:value="fzr_user"
				  >
					<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="margin-right: 25px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 10px;">{{item.label}}</div>
					
					<a-icon @click="delSelectFZR(index)" type="close-circle" />
				</div>
			</div>
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的内容：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 105px;">{{item.adv_name}}</div>
				</div>
			</div>
			
		</div>
	</a-modal>
	
	
	<!-- 批量搜索账户ID -->
	<plSearchID ref="refPlSearchID" @get-pl-id="getPlId"></plSearchID>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import plSearchID from "./components/plSearchID"
import adminSelect from "./components/adminSelect"
import { putUserList, accountWBDev, accountWBadv, WbSetAdvUser, putDataMenu } from '@/request/api'
import wbAgentPage from "./WBcomponent/wbAgentPage"
import wbDevPage from "./WBcomponent/wbDevPage"
export default {
	name: 'accountWB_',
	components: {
		plSearchID,adminSelect, wbAgentPage,wbDevPage
	},
	data() {
		return {
			titleTab: [
				{label: "推广账户管理", select: true , value: 0 },
				{label: "授权账户管理", select: false , value: 2 },
				{label: "开发者账户管理", select: false , value: 1 },
			],
			content_type: 0, // 页面内容展现类型
			
			personChargeList: {}, // 负责人列表
			ToutiaoList: [], // 开发者账户
			
			r_adv_name: null, // 推广账户名称
			r_admin_id: null, // 负责人id
			r_account_id: "", // 开发者账户id
			r_page: 1,
			r_limit: 100,
			table_total: 0,
			
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"推广账户ID", width:120, type:"adv_id", },
				{title:"推广账户名称", width:130, type:"adv_name", }, 
				{title:"负责人", width:130, type:"admin_user", },
				{title:"审核状态", width:100, type:"effective_status", },
				{title:"微博登录账户", width:160, type:"account_login", },
				{title:"是否授权", width:100, type:"auth", },
				{title:"授权有效期", width:150, type:"refresh_expires_in", },
				{title:"授权开发者账户", width:140, type:"account_name", },
				{title:"开发者账户APPID", width:140, type:"appid", },
				// {title:"是否开启同步数据", width:140, type:"sync_data", },
				
			],
			tableShowData: [],
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1000,
			search_button_loading: false,
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量设置负责人
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			
			// 筛选条件部分
			filterData: {
				op_id:{
					list: [{}],
				},
				media_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				gzh_id:{
					list: [{}],
				},
				book_type: {
					list: [{}],
				}
				
			}, // 筛选条件数组
			
			// 批量搜索账户ID
			pl_text_content: [], // 批量粘贴过来，分隔过后的数据
			
			fzr_user: undefined,
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle, 60)
		that.table_scroll_width = table_info.table_width - 60 // 上一级的一个大盒子有一个左右的内边距，-60就是为了消除这个边距（并不是最外面盒子的边距）
		
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
		
		putDataMenu().then(res=>{
			that.filterData = res.data.data.filter
		})
		
		accountWBDev().then(res=>{
			that.ToutiaoList = res.data.data.data
		})
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				if(e.value == 0 || e.value == 1){
					this.searchButton('button')
				}
			}
			console.log(this.content_type)
		},
		handleChangeA(e){
			this.r_admin_id = e
		},
		handleChangeB(e){
			this.r_account_id = e 
		},
		
		
		// 批量设置负责人
		handleChangeD(e){
			console.log(e);
			this.fzr_user = e
			
			let ttt = true
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		
		// 搜索
		searchButton(type){
			let that = this
			
			if(type != '分页'){
				that.selectedData = [] // 已选内容清空
			}
			
			if(type == 'button'){
				that.r_page = 1
			}
			if(that.content_type == 0){ // 推广账户管理
				that.search_button_loading = true
				let r_data = {
					page: that.r_page,
					limit: that.r_limit,
					adv_name: that.r_adv_name, // 推广账户名称
					admin_id: that.r_admin_id, // 负责人id
					account_id: that.r_account_id, // 开发者账户id
					
				}
				if(type == '批量账户ID'){
					r_data.adv_id = that.pl_text_content
				}
				accountWBadv(r_data).then(res=>{
					console.log("搜索",res);
					
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						let data = res.data.data.data
						data.forEach(res=>{
							res.checked = false // 用于多选和单选
							
							if(res.refresh_expires_in){
								let date = new Date(res.refresh_expires_in)
								let ddd = date.getTime() - Date.now()
								if(ddd > 0 && ddd < 864000000){ // 相差10天内，表示快要过期
									res.refresh_expires_text = "快过期"
								}
								else if(date.getTime() - Date.now() <= 0){
									res.refresh_expires_text = "已过期"
								}
								else { // 表示还有日期，还不会过期
									res.refresh_expires_text = ""
								}
							}
							else {
								res.refresh_expires_text = null
							}
						})
						console.log("data",data)
						if(that.selectedData.length > 0){
							let ccc = true
							let iii = 0 // 用于判断是否全选
							data.forEach(res=>{
								that.selectedData.forEach(res_r=>{
									if(res.id === res_r.id){
										res.checked = true
										ccc = false
										iii = iii + 1
									}
								})	
							})
							console.log("iii",iii)
							if(iii === 20){ // 全选
								that.indeterminate = false
								that.checkAll = true
							}
							else {
								if(ccc){
									that.checkAll = false
									that.indeterminate = false
								}
								else {
									that.checkAll = false
									that.indeterminate = true
								}
							}
							
						}
						else {
							console.log("that.checkAll",that.checkAll)
							that.checkAll = false
							that.indeterminate = false
						}
						
						that.search_button_loading = false
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total
						that.tableShowData = data
					}
					else {
						that.search_button_loading = false
						that.checkAll = false
						that.indeterminate = false
						that.selectedData = []
						that.tableShowData.forEach(res=>{
							res.checked = false
						})
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(that.content_type == 1){ // 开发者账户管理
				// 开发者账户
				
			}
		},
		// 批量设置负责人
		setFZR(){
			if(this.selectedData.length > 0){
				this.pl_modal = true
			}
			else {
				this.$message.warning('请先选择内容');
			}
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		// 设置负责人
		setFZRShow(e){
			let that = this
			this.selectedData = []
			this.selectedData.push(e)
			console.log(e);
			// e.auth.forEach(res=>{
			// 	let obj = {
			// 		label: res.admin_name,
			// 		key: res.admin_id
			// 	}
			// 	this.pl_select_admin.push(obj)
			// })
			for (let key in e.admin_user) {
				let obj = {
					label: e.admin_user[key],
					key: key
				}
				this.pl_select_admin.push(obj)
			}
			this.pl_modal = true
		},
		
		// 批量设置负责人
		plOk(){
			let that = this
			if(that.pl_select_admin.length > 0){ // 得选择设置负责人
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.id)
				})
				console.log("i_data",i_data);
				
				WbSetAdvUser({
					admin_id: a_data,
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					console.log("批量设置设置负责人",res);
					that.selectedData = []
					that.plCancel()
					that.$message.success('设置成功');
					that.searchButton()
				})
			}
			else {
				this.$message.warning('请先选择设置负责人');
			}
			
			
		},
		// 批量设置管理员弹窗取消按钮
		plCancel(){
			// if(this.pl_loading){
			// 	return 
			// }
			
			this.pl_modal = false
			this.pl_select_admin = []
			this.pl_loading = false
			
			this.fzr_user = undefined
		},
		// 删除选择的负责人
		delSelectFZR(index){
			this.pl_select_admin.splice(index,1)
		},
		
		// 批量搜索账户ID
		showPlAccID(){
			this.$refs.refPlSearchID.plAccountID()
		},
		getPlId(ttt){
			this.pl_text_content = ttt
			this.searchButton('批量账户ID')
		}
	},
	filters: {
		// 审核状态
		shStatusFilters(value){
			let vvv = ""
			if(value == 1){
				vvv = "未授权"
			}
			else if(value == 2){
				vvv = "正常"
			}
			else if(value == 3){
				vvv = "冻结"
			}
			else if(value == 4){
				vvv = "解绑"
			}
			else if(value == 9){
				vvv = "删除"
			}
			
			return vvv
		},
	}
}	
</script>

<style scoped>
.class-title {
	width: 100px;
}
</style>